import { V1 } from 'api/v1/V1';
import { getClientTimeInISO } from 'library/utils/dateTime/clientTime';

export interface PrintHealthCheckUserSettings {
	printQr: boolean;
	printEstimatedHours: boolean;
	printUsedHours: boolean;
	printConfiguration: boolean;
	printEndCustomer: boolean;
	printCampaigns: boolean;
	printCoverage: boolean;
	printNotes: boolean;
	printRecommendedActions: boolean;
	printSignatures: boolean;
	printAttachedFiles: boolean;
}

type GetHealthCheckPdfRequest = Parameters<
	InstanceType<typeof V1>['downloadHealthCheckPdf']
>['0'];

export const HEALTH_CHECK_PDF_DEFAULTS: PrintHealthCheckUserSettings = {
	printQr: true,
	printEstimatedHours: true,
	printUsedHours: true,
	printConfiguration: true,
	printEndCustomer: true,
	printCampaigns: true,
	printCoverage: true,
	printNotes: true,
	printRecommendedActions: true,
	printSignatures: true,
	printAttachedFiles: true,
};

export const mapFormToHealthCheckPdfRequest = (
	id: number,
	form: PrintHealthCheckUserSettings,
	vppnReverseProxyType: string | undefined,
	isDealer: boolean,
	additionalText: string | undefined,
	language: string
): GetHealthCheckPdfRequest => ({
	id,
	vppnReverseProxyType,
	language,
	additionalText: additionalText ?? '',
	// workaround for sending date as date, generated client sends it as string
	protocolGenerationClientDate: getClientTimeInISO() as unknown as Date,
	printQr: isDealer ? form.printQr : false,
	printEstimatedHours: form.printEstimatedHours,
	printUsedHours: form.printUsedHours,
	printConfiguration: form.printConfiguration,
	printEndCustomer: form.printEndCustomer,
	printCampaigns: form.printCampaigns,
	printCoverage: form.printCoverage,
	printNotes: form.printNotes,
	printRecommendedActions: form.printRecommendedActions,
	printSignatures: form.printSignatures,
	printAttachedFiles: form.printAttachedFiles,
});

export const mapRecordToHealthCheckUserSettings = (
	dict?: Record<string, boolean>
): PrintHealthCheckUserSettings | undefined => {
	if (!dict) {
		return undefined;
	}

	const result = { ...HEALTH_CHECK_PDF_DEFAULTS };

	(Object.keys(result) as (keyof PrintHealthCheckUserSettings)[]).forEach(
		(key) => {
			if (typeof dict[key] === 'boolean') {
				result[key] = dict[key];
			}
		}
	);

	return result;
};
